module.exports = __webpack_public_path__ + "img/unknown.060ff0b.svg";